<template>
    <div class="crm-main-cont">

        <a-tree
                class="fl org-tree"
                @select="onSelect"
                :selectedKeys="selectedKeys"
                :treeData="treeData"
        />

        <div class="fl org-main">
            <div class="btns-group">
                <a-button @click="addParam" type="primary">
                    添加
                </a-button>
            </div>
            <br>

            <a-table
                    class="param-list"
                    :columns="columns"
                    :dataSource="paramList"
                    @change="handleTableChange"
                    bordered
                    rowKey="id"
                    :pagination="pagination"
            >
                <template slot="operation" slot-scope="text, record">
                    <div class="editable-row-operations">
                        <a @click="() => edit(record)">修改</a>
                        <a @click="() => del(record)">删除</a

                        >
                    </div>
                </template>
            </a-table>
        </div>

        <a-drawer
                :title="title"
                :width="650"
                @close="onClose"
                :visible="visible"
                :wrapStyle="{ height: 'calc(100% - 108px)', overflow: 'auto', paddingBottom: '108px'}"
        >
            <a-form v-if="!editStatus && visible" :form="form" layout="vertical">
                <a-row :gutter="16">
                    <a-col :span="12">
                        <a-form-item label="参数">
                            <a-input
                                    v-decorator="[
                                    'param',
                                    {
                                        rules: [
                                            {
                                                required: true,
                                                message: '请填写参数'
                                            }
                                        ]
                                    }
                                ]"
                            />
                        </a-form-item>
                    </a-col>
                    <a-col :span="12">
                        <a-form-item label="参数说明">
                            <a-input
                                    v-decorator="[
                                    'desc',
                                    {
                                        rules: [
                                            {
                                                required: true,
                                                message: '请填写参数说明'
                                            }
                                        ]
                                    }
                                ]"
                            />
                        </a-form-item>
                    </a-col>
                </a-row>
                <br>
                <a-row :gutter="16">
                    <a-col :span="12">
                        <a-form-item label="排序">
                            <a-input
                                    v-decorator="[
                                    'sort',
                                    {
                                        rules: [
                                            {
                                                required: true,
                                                message: '请填进行排序'
                                            }
                                        ]
                                    }
                                ]"
                            />
                        </a-form-item>
                    </a-col>
                </a-row>
                <br>

                <div class="submit-btn">
                    <a-button @click="handleSubmit" type="primary"
                    >提交</a-button
                    >
                </div>
            </a-form>
            <a-form v-if="editStatus && visible" :form="form2">
                <a-row :gutter="16">
                    <a-col :span="12">
                        <a-form-item label="参数">
                            <a-input
                                    v-decorator="[
                                    'param',
                                    {
                                        rules: [
                                            {
                                                required: true,
                                                message: '请填写参数'
                                            }
                                        ]
                                    }
                                ]"
                            />
                        </a-form-item>
                    </a-col>
                    <a-col :span="12">
                        <a-form-item label="参数说明">
                            <a-input
                                    v-decorator="[
                                    'desc',
                                    {
                                        rules: [
                                            {
                                                required: true,
                                                message: '请填写参数说明'
                                            }
                                        ]
                                    }
                                ]"
                            />
                        </a-form-item>
                    </a-col>
                </a-row>
                <br>
                <a-row :gutter="16">
                    <a-col :span="12">
                        <a-form-item label="排序">
                            <a-input
                                    v-decorator="[
                                    'sort',
                                    {
                                        rules: [
                                            {
                                                required: true,
                                                message: '请填进行排序'
                                            }
                                        ]
                                    }
                                ]"
                            />
                        </a-form-item>
                    </a-col>
                </a-row>
                <br>
                <div class="submit-btn">
                    <a-button @click="updateSysParam" type="primary"
                    >修改</a-button
                    >
                </div>
            </a-form>
        </a-drawer>

        <!--<template slot="userType" slot-scope="text">
                {{ text === '1' ? "单位管理员" : "普通工作人员" }}
            </template>
            <template slot="userStatus" slot-scope="text">
                {{ text === '1' ? "启用" : "禁用" }}
            </template>
            <template slot="auth" slot-scope="text, record">
                <a @click="() => showAuth(record)">查看</a>
            </template>
            -->
        <!--<a-modal
                title=" "
                v-model="authVisible"
                @ok="updateAuth"
                @cancel="cancelAuth"
        >
        </a-modal>-->
    </div>
</template>

<script>

    const columns = [
        {
            title: "参数",
            dataIndex: "param",
            scopedSlots: { customRender: "param" },
        },
        {
            title: "说明",
            dataIndex: "desc",
            scopedSlots: { customRender: "desc" },
        },
        {
            title: "标识",
            dataIndex: "mark",
            scopedSlots: { customRender: "mark" },
        },
        {
            title: "排序",
            dataIndex: "sort",
            scopedSlots: { customRender: "sort" },
        },
        {
            title: "操作",
            dataIndex: "operation",
            scopedSlots: { customRender: "operation" },
            width: 150,
        }
    ];

    import {
        getParam,
        getAllTree,
        addSysParam,
        updateSysParam,
        deleteById
    } from "@/api/sysparam/sysParam";


    export default {
        name: "sysParam",
        data() {
            return {
                columns,
                form: this.$form.createForm(this),
                form2: this.$form.createForm(this),
                editStatus: false,
                visible: false,
                title: "添加用信单位用户",
                layoutStyle: {
                    labelCol: {
                        span: 7
                    },
                    wrapperCol: {
                        span: 16
                    }
                },
                layoutStyle2: {
                    labelCol: {
                        span: 7
                    },
                    wrapperCol: {
                        span: 17
                    }
                },
                paramList: [],
                selectedKeys: [],
                treeData: [],
                search: {
                    pageNum: ""
                },
                pagination: {
                    total: 40,
                    current: 1,
                    pageSize: 20
                },
                editItem: "",
            };
        },
        beforeRouteEnter(to, from, next) {
            getAllTree()
            .then(res => {
                next(vm => {
                    vm.$ajaxAfter(res).then(() => {
                        if (res.data.data.Tree.length) {
                            vm.treeData = vm.setTree(
                                res.data.data.Tree
                            );
                            vm.selectedKeys = [
                                res.data.data.Tree[0].param
                            ];
                            vm.initparamList({
                                mark:
                                res.data.data.Tree[0].param
                            });
                        } else {
                            vm.$message.error("请先创建行政区！").then(() => {
                                vm.$router.push({
                                    name: "om_region_manage"
                                });
                            });
                        }
                    });
                });
            })
            .catch(() => {
                next(vm => {
                    vm.$message.error("服务器出错！请稍后再试!");
                    vm.$Progress.fail();
                });
            });
        },
        methods: {
            setTree(trees) {
                if(trees.isleaf === '1') {
                    trees.map(tree => {
                        Object.assign(tree, {
                            title: tree.desc,
                            key: tree.param,
                            isLeaf: true
                        });
                        if (tree.children) {
                            this.setTree(tree.children);
                        }
                    });
                }else{
                    trees.map(tree => {
                        Object.assign(tree, {
                            title: tree.desc,
                            key: tree.param,
                        });
                        if (tree.children) {
                            this.setTree(tree.children);
                        }
                    });
                }
                return trees;
            },
            //初始化数据
            initparamList(mark) {
                getParam(mark,this.search.pageNum)
                    .then(res => {
                        this.$ajaxAfter(res).then(() => {
                            this.paramList = res.data.data.page.list;
                            Object.assign(this.pagination, {
                                total: res.data.data.page.total,
                                pageSize: res.data.data.page.pageSize,
                                pageNum: res.data.data.page.pageNum
                            });
                        });
                    })
                    .catch(() => {
                        this.$message.error("服务器出错！请稍后再试!");
                    });
            },
            onSelect(selectedKeys) {
                if (selectedKeys.length) {
                    this.selectedKeys = selectedKeys;
                    if (selectedKeys !== this.selectedKeys[0]) {
                        this.initparamList({mark: this.selectedKeys[0] });
                    }
                }
            },
            addParam() {
                this.title = "添加参数";
                this.editStatus = false;
                this.visible = true;
            },
            //获取单位列表数据
            onClose() {
                this.visible = false;
            },
            //提交修改或添加
            handleSubmit(e) {
                e.preventDefault();
                console.log(this.selectedKeys[0]);
                this.form.validateFields((err, values) => {
                    if (!err) {
                        values.mark = this.selectedKeys[0];
                        addSysParam(values)
                            .then(res => {
                                this.$ajaxAfter(res).then(() => {
                                    this.$message.success("创建参数成功！");
                                    this.initparamList({mark : this.selectedKeys[0]});
                                    this.visible = false;
                                });
                            })
                            .catch(() => {
                                this.$message.error("服务器出错！请稍后再试!");
                            });
                    }
                });
            },
            handleTableChange(page) {
                this.search.pageNum = page.current;
                this.initparamList();
            },
            edit(record) {
                this.editItem = record;
                this.title = "修改参数："+record.param+"-"+record.desc;
                this.visible = true;
                this.editStatus = true;
                setTimeout(() => {
                    this.form2.setFieldsValue({
                        param: record.param || "",
                        desc: record.desc || "",
                        sort: record.sort || "",
                    });
                }, 0);
            },
            updateSysParam(e) {
                e.preventDefault();
                this.form2.validateFields((err, values) => {
                    if (!err) {
                        values.id = this.editItem.id;
                        updateSysParam(values)
                            .then(res => {
                                this.$ajaxAfter(res).then(() => {
                                    this.$message.success("修改成功！");
                                    this.initparamList({mark : this.selectedKeys[0]});
                                    this.editStatus = false;
                                    this.visible = false;
                                });
                            })
                            .catch(() => {
                                this.$message.error("服务器出错！请稍后再试!");
                            });
                    }
                });
            },
            del(record){
                deleteById(record.id)
                    .then(res=>{
                        this.$ajaxAfter(res).then(() => {
                            this.$message.success("已成功删除！");
                            this.initparamList({mark : this.selectedKeys[0]});
                        });
                    })
                    .catch(() => {
                       this.$message.error("服务器出错！请稍后再试!");
                    });
            },
        }
    };
</script>

<style>
    .search-box .ant-form-item-label {
        width: 60px;
        text-align: left;
    }
</style>
<style scoped lang="less">
    .f14 {
        font-size: 14px;
    }
    .search-box {
        .ant-form-item {
            display: inline-block;
            min-width: 280px;
        }

        .ant-select {
            width: 100%;
        }
    }

    .btns-group button {
        margin-right: 10px;
    }

    .submit-btn {
        position: absolute;
        left: 0;
        bottom: 0;
        width: 100%;
        border-top: 1px solid #e9e9e9;
        padding: 10px 16px;
        background: #fff;
        text-align: right;
    }

    .ant-row > div {
        height: 63px;
    }
    .unitUser-list {
        margin-top: 30px;
    }
    .editable-row-operations a {
        margin-right: 10px;
    }
    .account-info {
        margin-bottom: 10px;
    }
    .auto-label {
        font-size: 14px;
    }
    .auth-list {
        display: flex;
        align-items: center;
        border-bottom: 1px solid #e8e8e8;
        padding: 10px 0;
    }
    .menu-top {
        flex-shrink: 0;
        width: 120px;
    }
    .org-tree {
        min-width: 150px;
        flex-shrink: 0;
    }
    .org-main {
        width: 80%;
        margin-left: 30px;
    }
</style>
